<template>
  <div>
    <fingerprints></fingerprints>
  </div>
</template>

<script>
import Fingerprints from "vue-fingerprints";
export default {
  components: {
    Fingerprints,
  },
};
</script>

<style></style>
